<template>
  <v-alert
    v-if="!loading && showAlert"
    type="info"
    icon="info"
    color="#dedede"
    outlined
    dense
  >
    <template slot="prepend">
      <v-icon color="primary" class="mr-4">info</v-icon>
    </template>
    <v-row align="center">
      <v-col :cols="$vuetify.breakpoint.smAndUp ? false : 12" :class="{'grow': $vuetify.breakpoint.smAndUp}">
        <em class="body-2"><span style="color: #000000DE;">You exceeded $15,000 volume over the last 3 months. </span> <span class="underline primary--text pointer" @click="goToLink('https://integrate.clover.com/partner/sweep-and-go')">Get a free quote from Clover Connect <v-icon color="primary" small class="ml-1">call_made</v-icon></span></em>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndUp ? false : 12" :class="{'shrink': $vuetify.breakpoint.smAndUp}">
        <v-btn color="primary" text @click="onGotIt()">Got it</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapGetters } from 'vuex'
import { CHECK_AUTH } from "@/store/actions.type"

export default {
  name: "PaymentProcessorAlert",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    loading: false,
    showAlert: false,
    loadingPaymentsSum: false,
    paymentsSum: null,
    tipsSum: null
  }),
  mounted() {
    this.getPaymentsSum()
  },
  methods: {
    getPaymentsSum () {
      if (this.gotItInLastThreeMonths) { return }
      this.loadingPaymentsSum = true
      let body = {
        start_date: moment().subtract(3, "months").format("YYYY[-]MM[-]DD"),
        end_date: moment().format("YYYY[-]MM[-]DD")
      }
      ApiService.get('/payments/sum_payments', body)
        .then(response => {
          this.paymentsSum = response.data.sum_payments
          this.tipsSum = response.data.sum_tip_amounts
          this.loadingPaymentsSum = false
        })
        .catch(error => {
          console.log(error);
          this.paymentsSum = null
          this.tipsSum = null
          this.loadingPaymentsSum = false
        })
    },
    onGotIt () {
      this.showAlert = false
      let body = {'user_settings': _.cloneDeep(this.userSettings)}
      let valueString = moment().unix()
      if(body.user_settings.some(i => i.key === 'clover_offer')) {
          body.user_settings.find(i => i.key === 'clover_offer').value = valueString
      } else {
          body.user_settings.push({
              'key': 'clover_offer',
              'value': valueString
          })
      }

      ApiService.post('/auth/user_settings', body)
          .then(response => {
              this.$store.dispatch(CHECK_AUTH)
          })
          .catch(({ response }) => {
              console.log(response);
          })
    },
    goToLink(link) {
      window.open(link, '_blank')
    }
  },
  computed: {
    ...mapGetters(['paymentProcessor', 'userSettings']),
    gotItInLastThreeMonths () {
      return !this.no_data.includes(this.userSettings) &&
        Array.isArray(this.userSettings) &&
        this.userSettings.some(i => i.key === 'clover_offer' &&
          !this.no_data.includes(i.value) &&
          moment.unix(Number(i.value)).isAfter(moment().subtract(3, "months"))
        )
    },
    showAlertDependencies () {
      return `${this.paymentsSum}-${this.tipsSum}-${this.loadingPaymentsSum}-${this.paymentProcessor}-${this.gotItInLastThreeMonths}`
    }
  },
  watch: {
    'showAlertDependencies': function(val) {
      if (
        !this.gotItInLastThreeMonths &&
        this.paymentProcessor === 'stripe' &&
        !this.loadingPaymentsSum &&
        (
          !this.no_data.includes(this.paymentsSum) ||
          !this.no_data.includes(this.tipsSum)
        )
      ) {
        let payments = parseFloat(this.paymentsSum)
        let tips = parseFloat(this.tipsSum)
        let sum = payments + tips
        if (
          (typeof sum === 'number' && sum > 3000) ||
          (typeof payments === 'number' && payments > 3000) ||
          (typeof tips === 'number' && tips > 3000)
        ) {
          this.showAlert = true
        }
      }
    },
  },
}

</script>